import { Row, Table } from 'antd';
import { useState } from 'react';
import { useAppDispatch } from '../../../../app/hooks';
import { setModal } from '../../../../common/slices/commonSlice';
import { perProps } from '../../../../common/types/commonTypes';
import BreadCrumb from '../../../../components/common/breadCrumb/BreadCrumb';
import CommonTableHeader from '../../../../components/common/CommonTableHeader';
import LoadingIndicator, {
  loadingIndicator,
} from '../../../../components/common/spinner/LoadingIndicator';
import TransportTypeAddModal from '../modals/TransportTypeAddModal';
import TransportTypeEditModal from '../modals/TransportTypeEditModal';
import { ITransportType } from '../types/transportTypeTypes';
import { transportColumn } from '../utils/utils';
import { useGetAllTransportTypesWithPaginationQuery } from '../endpoints/transportTypeEndpoints';

const TransportType = ({ permission }: perProps) => {
  const dispatch = useAppDispatch();
  const [editInfo, setEditInfo] = useState<ITransportType | null>(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
  });

  const handlePaginationChange = (current: number, pageSize: number) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current,
      pageSize,
    }));
  };

  const showModal = () => {
    dispatch(setModal(true));
  };
  const {
    isLoading,
    data: transportType,
    refetch,
  } = useGetAllTransportTypesWithPaginationQuery(pagination, {
    selectFromResult: (cache) => {
      const data = cache.data?.data;
      const count = cache.data?.count;
      const dataToReturn: ITransportType[] = [];
      const TransportTypeNameList: string[] = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          TransportTypeNameList.push(element.ttype_name);
          dataToReturn.push({
            ...element,
            key: i + 1,
          });
        }
      }
      return { ...cache, data: { dataToReturn, TransportTypeNameList, count } };
    },
  });

  return (
    <div>
      <BreadCrumb
        arrOfOption={['Configuration', 'Transport Types']}
        refetch={refetch}
        reloaderSize='small'
      />
      <CommonTableHeader
        width
        align
        title='Transport Types'
        modalTitle={editInfo ? 'Edit Transport Type' : 'Add New Transport Type'}
        button_text='Add New Transport Type'
        permission={permission?.['create:any']}
        element={
          editInfo ? (
            <TransportTypeEditModal
              info={editInfo}
              TransportTypeNameList={transportType.TransportTypeNameList}
              setNull={setEditInfo}
            />
          ) : (
            <TransportTypeAddModal
              TransportTypeNameList={transportType.TransportTypeNameList}
            />
          )
        }
        setNull={setEditInfo}
      />
      <Row justify={'center'}>
        <Table
          size='small'
          style={{ width: 900 }}
          bordered
          rowKey={(e) => e.ttype_id}
          pagination={
            transportType?.count !== undefined && transportType?.count < 20
              ? false
              : {
                ...pagination,
                total: transportType?.count,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '200', '500'],
                onChange: handlePaginationChange,
              }
          }
          columns={transportColumn({
            setEditInfo,
            showModal,
            permission,
            pagination,
          })}
          dataSource={transportType.dataToReturn}
          scroll={{ x: true }}
          loading={{ spinning: isLoading, indicator: loadingIndicator }}
        />
      </Row>
      {isLoading && <LoadingIndicator />}
    </div>
  );
};

export default TransportType;
